import Settings from '../olr-common/Settings';

export default function AnnouncementController($location, $scope, AnnouncementService, localStorageService, Upload, $mdToast, $q, StudentService) {

  var self = this;

  $scope.currentNavItem = 'page1';

	self.readonly = false;
	self.selectedItem = null;
	self.searchText = null;
	//self.querySearch = querySearch;
	//self.listItems = loadClassRooms();
	self.selectedItemsForEmail = [];
	self.numberChips = [];
	self.numberChips2 = [];
	self.numberBuffer = '';
	self.autocompleteDemoRequireMatch = true;
	//self.transformChip = transformChip;
	$scope.showSelectClassError = false;

	self.uploadContent = {'subject': '', 'message': ''};

	var showToast = function(){
        $mdToast.show(
          $mdToast.simple()
            .textContent('Announcement Posted Successfully')
            .position('top right')
            .hideDelay(3000)
        );
    };



    var pendingSearch, cancelSearch = angular.noop;
    var cachedQuery, lastSearch;

    //self.allContacts = loadContacts();
    //self.contacts = [self.allContacts[0]];
    self.asyncContacts = [];
    self.filterSelected = true;

    //self.querySearch = querySearch;
    self.delayedQuerySearch = delayedQuerySearch;

    /**
     * Search for contacts; use a random delay to simulate a remote call
     */
    // function querySearch (criteria) {
    //   cachedQuery = cachedQuery || criteria;
    //   console.log(criteria);
    //   return cachedQuery ? self.allContacts.filter(createFilterFor(cachedQuery)) : [];
    // }

    /**
     * Async search for contacts
     * Also debounce the queries; since the md-contact-chips does not support this
     */
    function delayedQuerySearch(criteria) {
    	var results =[];
      cachedQuery = criteria;
      if ( !pendingSearch || !debounceSearch() )  {
        cancelSearch();

        return pendingSearch = $q(function(resolve, reject) {
          // Simulate async search... (after debouncing)
          cancelSearch = reject;
          if(cachedQuery){
	          StudentService.getStudentsByChar(cachedQuery).then(function(resp){
	            results = resp.data;
	            var classrooms = localStorageService.get('classrooms');
	            //debugger;
	            var string = cachedQuery.toString();
	            for(var i=0; i<classrooms.length;i++){
	            	var classRoomName = classrooms[i].classRoomName.toLowerCase();
	            	if(classRoomName.indexOf(cachedQuery) > -1){
	            		var classToStuObj = {'studentName': classrooms[i].classRoomName, 'studentId': classrooms[i].subjectName, 'isClass': true,
	            		 'classRoomId': classrooms[i].classRoomId, 'subjectId': classrooms[i].subjectId};
	            		results.push(classToStuObj);
	            	}
	            }
	            resolve( results );
	          });
	        }else{
	          results = [];
	          resolve(results);
	        }
          // $timeout(function() {

          // 	console.log(self.querySearch());

          //   resolve( self.querySearch() );

          //   refreshDebounce();
          // }, Math.random() * 500, true)
        });
      }

      return pendingSearch;
    }

    function refreshDebounce() {
      lastSearch = 0;
      pendingSearch = null;
      cancelSearch = angular.noop;
    };

    /**
     * Debounce if querying faster than 300ms
     */
    function debounceSearch() {
      var now = new Date().getMilliseconds();
      lastSearch = lastSearch || now;

      return ((now - lastSearch) < 300);
    };

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(contact) {
        return (contact._lowername.indexOf(lowercaseQuery) != -1);;
      };

    }

    function loadContacts() {

      var contacts = localStorageService.get('classrooms');

      return contacts.map(function (c, index) {
        var cParts = c.split(' ');
        var contact = {
          'studentName': c[index].classRoomName,
          'studentId': cParts[0][0].toLowerCase() + '.' + cParts[1].toLowerCase() + '@example.com',
        };
        contact._lowername = contact.name.toLowerCase();
        return contact;
      });
    }







	/**
	 * Return the proper object when the append is called.
	 */
	// function transformChip(chip) {
	//   // If it is an object, it's already a known chip
	//   if (angular.isObject(chip)) {
	//     return chip;
	//   }
	// }

	// function querySearch (query) {
	//   $scope.showSelectClassError = false;
	//   var results = query ? self.listItems.filter(createFilterFor(query)) : [];
	//   return results;
	// }

	// /**
	//  * Create filter function for a query string
	//  */
	// function createFilterFor(query) {
	//   var lowercaseQuery = angular.lowercase(query);

	//   return function filterFn(loadingItem) {
	//     return (loadingItem._lowerClassName.indexOf(lowercaseQuery) === 0) ||
	//         (loadingItem._lowerSubject.indexOf(lowercaseQuery) === 0);
	//   };

	// }

	// function loadClassRooms() {
	//   var classRooms = localStorageService.get('classrooms');
	//   if(classRooms){
	//   	return classRooms.map(function (loadItem) {
	// 	    loadItem._lowerClassName = loadItem.classRoomName.toLowerCase();
	// 	    loadItem._lowerSubject = loadItem.subjectName.toLowerCase();
	// 	    return loadItem;
	// 	});
	//   }
	// }

	$scope.sendUpload = function(){
		debugger;
		if(self.asyncContacts.length === 0){
			$scope.showSelectClassError = true;
			return;
		}

		if(self.onlineForm.$invalid){
        angular.forEach(self.onlineForm, function(val, key) {
          if (!key.match(/\$/)) {
            val.$dirty = true;
            val.$touched = true;
          }
        });
        return;
      }
		var reqObj = {'selectedClasses': [],'selectedStudents': [] ,'announcementType': 'uploadOnline', 'subject': self.uploadContent.subject, 'message': self.uploadContent.message};
		var fileExist = false;
		var fileName = '';
		if(self.upload_form.file.$valid && self.file){
			fileExist = true;
			fileName = self.file.name;
		}
		reqObj.fileExist = fileExist;
		reqObj.fileName = fileName;

		for(var i=0;i<self.asyncContacts.length;i++){
			if(self.asyncContacts[i].isClass){
				reqObj.selectedClasses.push({'classRoomId': self.asyncContacts[i].classRoomId, 'subjectId': self.asyncContacts[i].subjectId, 
				'subjectName': self.asyncContacts[i].studentId});
			}else{
				reqObj.selectedStudents.push({'studentId': self.asyncContacts[i].studentId, 'studentName': self.asyncContacts[i].studentName});
			}
			
		}
		
		AnnouncementService.saveAnn(reqObj).then(function(resp){
			if(fileExist){
				Upload.upload({
	                url: Settings.backendEnv + '/api/v1/upload',
	                headers: {
	                   'filetoken': resp.data.annId
	                 },
	                data:{file:self.file} //pass file as data, should be user ng-model
	            }).then(function (resp) { //upload function returns a promise
	                if(resp.data.error_code === 0){ //validate success
	                	showToast();
	                    //$window.alert('Success ' + resp.config.data.file.name + 'uploaded. Response: ');
	                } else {
	                    //$window.alert('an error occured');
	                }
	            }, function (resp) { //catch error
	                console.log('Error status: ' + resp.status);
	                //$window.alert('Error status: ' + resp.status);
	            }, function (evt) { 
	                console.log(evt);
	                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	                self.progress = 'progress: ' + progressPercentage + '% '; // capture upload progress
	            });
			}
			else{
				showToast();
			}
		});
	}

}



/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-announcement/AnnouncementController.js
 **/